<template>
  <div class="usagemonth-machine-list">
    <!-- 过滤 -->
    <div class="table-list">
      <div class="header">
        <div class="search-content">
          <el-form :inline="true" @submit.native.prevent>
            <!-- <el-form-item style="float: right; margin-right: 0">
              <custom-column ref="column"></custom-column>
            </el-form-item> -->

            <el-form-item style="float: right" v-if="funcView.usagemonth_machine_export">
              <el-button class="custom-btn" icon="icon icon-export-excel left-icon" type="info" round @click="exportRecord">{{ $t('Common.com_export') }}</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
            </el-form-item>
            <el-form-item style="float: right">
              <el-date-picker
                v-model="reportMonthTime"
                type="monthrange"
                range-separator="—"
                :format="$getElFormat('yyyy-MM', true)"
                value-format="yyyy-MM"
                align="right"
                placeholder=""
                :picker-options="pickerOptionsMonth"
                :clearable="false"
                @change="onPageChange({ page: 1 })"
                :start-placeholder="$t('Common.com_start_month')"
                :end-placeholder="$t('Common.com_end_month')"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 过滤 -->
      <div class="query-filter" style="margin-top: 24px; width: 100%; padding: 0">
        <div class="params-form" v-show="isFilter">
          <el-row :gutter="23">
            <el-col :span="8" v-if="isCoJv && showSubsidiary">
              <div class="item">
                <div class="label">{{ $t('usagemonth_machine_list.gong_si_ming_cheng') }}</div>
                <div class="value">
                  <el-input v-model="formSearch.customerName" @input="onPageChange({ page: 1 })" clearable :placeholder="$t('Common.com_please_input')"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('usagemonth_machine_list.xmqymcjsh') }}</div>
                <div class="value">
                  <el-input v-model="formSearch.search" @input="onPageChange({ page: 1 })" clearable :placeholder="$t('Common.com_please_input')"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('Common.com_belong_to_department') }}</div>
                <div class="value">
                  <custom-select
                    url="DepartmentTree"
                    v-model="formSearch.departmentId"
                    :model="formSearch"
                    :props="{ label: 'bizName', value: 'bizId', checkStrictly: true, map: { bizName: 'departmentName' } }"
                    :params="{ isCountDevice: 1 }"
                    :placeholder="$t('Common.com_please_select')"
                    width="100%"
                    ref="tag"
                    type="tree"
                    filterable
                    :dataFilter="departmentTreeFilter"
                    @treeValChange="onPageChange({ page: 1 })"
                    @treeValChangeLabel="onDepartmentLabel"
                    @getList="onDepartmentList"
                    :clearable="false"
                  ></custom-select>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="filter-values">
          <div class="label">{{ $t('Common.com_filter_item') }}</div>
          <div class="values">
            <el-tag
              v-if="formSearch.customerName"
              closable
              @close="
                formSearch.customerName = '';
                onPageChange({ page: 1 });
              "
            >
              {{ formSearch.customerName }}
            </el-tag>
            <el-tag
              v-if="formSearch.search"
              closable
              @close="
                formSearch.search = '';
                onPageChange({ page: 1 });
              "
            >
              {{ formSearch.search }}
            </el-tag>
            <el-tag
              v-if="formSearch.departmentId"
              closable
              @close="
                formSearch.departmentId = '';
                formSearch.departmentName = '';
                onPageChange({ page: 1 });
              "
            >
              {{ formSearch.departmentName }}
            </el-tag>
            <span class="clear" @click="onClear">{{ $t('Common.com_clear') }}</span>
          </div>
        </div>
      </div>
      <div class="table-bd">
        <el-table :data="tableList" height="100%" :index="true" @sort="sortChange" @column="setColumn" @filter="filterChange">
          <el-table-column
            v-for="(item, index) in tableColumn"
            :key="index"
            :index="index"
            :prop="item.columnCode"
            :label="item.columnName"
            :width="item.width"
            :formatter="item.isFormat ? formatColumn : null"
            :sortable="item.isSort ? 'custom' : null"
            :fixed="item.isLock ? 'right' : null"
            show-overflow-tooltip
          ></el-table-column>
          <template v-if="cleanColumn.length">
            <el-table-column v-for="(mtem, mndex) in monthArr" :label="mtem" :key="mtem" align="center">
              <template v-for="(item, index) in cleanColumn">
                <el-table-column
                  v-if="item.selected && item.columnCode !== 'cleanArea' && item.columnCode !== 'usageTime'"
                  :key="index"
                  :index="index"
                  :prop="`${item.columnCode}${mndex + 1}`"
                  :label="item.columnName"
                  :width="item.width"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  v-if="item.selected && item.columnCode === 'cleanArea'"
                  :key="index"
                  :index="index"
                  :prop="`${item.columnCode}${mndex + 1}`"
                  :label="`${item.columnName}(${$formatLenUnit()})`"
                  :width="item.width"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span>
                      {{ scope.row[`${item.columnCode}${mndex + 1}`] > 0 ? $numCommaSplit($formatLenLocal(scope.row[`${item.columnCode}${mndex + 1}`])) : scope.row[`${item.columnCode}${mndex + 1}`] }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="item.selected && item.columnCode === 'usageTime'"
                  :key="index"
                  :index="index"
                  :prop="`${item.columnCode}${mndex + 1}`"
                  :label="item.columnName"
                  :width="item.width"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row[`${item.columnCode}${mndex + 1}`] > 0 ? $formatSecToHh(scope.row[`${item.columnCode}${mndex + 1}`]) : scope.row[`${item.columnCode}${mndex + 1}`] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table-column>
          </template>

          <!-- 占位列 -->
          <el-table-column v-if="!tableColumn.length"></el-table-column>
        </el-table>
      </div>
      <div class="table-footer">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
      </div>
    </div>
  </div>

  <!-- </div> -->
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';

export default {
  name: 'usagemonth-machine-list',
  props: {},
  components: {},
  computed: {
    myTableColumn() {
      return this.tableColumn;
    },
  },
  data() {
    return {
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        bodyNum: '',
        customerName: '',
        search: '',
        showSubsidiary: '',
        departmentId: '',
        departmentName: '',
      },
      tableColumn: [],
      cleanColumn: [],
      totalRows: null,
      tableList: [],
      monthArr: [],
      isFilter: false,
      choiceDate: null,
      reportMonthTime: [`${moment(this.$getLocalTime()).subtract(3, 'months').format('YYYY-MM')}`, `${moment(this.$getLocalTime()).format('YYYY-MM')}`],
      pickerOptionsMonth: {
        firstDayOfWeek: 1,
        // 范围选最近4个月，且不能选择2016年之前的时间
        disabledDate: (time) => {
          // 禁用2016年之前的日期
          const minYearLimit = moment(this.$momentElLocal(moment('2016-01-01 00:00:00'))).valueOf();
          if (time < minYearLimit) {
            return true;
          }
          // 现有的禁用逻辑
          return this.choiceDate
            ? (!moment(time).isSame(moment(this.choiceDate).subtract(3, 'months'), 'months') && !moment(time).isSame(moment(this.choiceDate).add(3, 'months'), 'months'))
                || moment(time).isAfter(this.$getLocalTime(), 'day')
            : moment(time).isAfter(this.$getLocalTime(), 'day');
        },
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate = minDate.getTime();
          if (maxDate) {
            this.choiceDate = '';
          }
        },
      },
    };
  },
  watch: {},
  // created() {

  // },
  mounted() {
    if (this.getJump('search')) {
      this.formSearch.search = this.getJump('search');
    }
    this.getReportPage();
    this.getFuncView(null, () => {
      this.getTableColumn();
    });
  },
  methods: {
    departmentTreeFilter(obj) {
      const ret = [obj];
      const ret2 = this.removeEmptyChildren(ret);
      return ret2;
    },
    removeEmptyChildren(nodes) {
      return nodes.map((item) => {
        // 如果 children 存在且是空数组，则删除 children 属性
        if (Array.isArray(item.children) && item.children.length === 0) {
          const newItem = { ...item }; // 创建一个新的对象，避免直接修改原数据
          delete newItem.children; // 删除 children 属性
          return newItem; // 返回没有 children 属性的对象
        }

        // 如果有子节点，递归调用 removeEmptyChildren
        if (item.children && item.children.length > 0) {
          return { ...item, children: this.removeEmptyChildren(item.children) };
        }

        return item; // 其他情况直接返回
      });
    },
    onDepartmentList(list) {
      this.departmentList = list;
    },
    onDepartmentLabel(Label) {
      this.formSearch.departmentName = Label;
    },
    // 月 周 table
    getReportPage: function () {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.formSearch.ym = this.reportMonthTime ? this.reportMonthTime[1] : '';
      this.$getJSON(apis.portalSiteDeviceMonthPage, {
        ...this.formSearch,
        departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '',
      }).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 获取表格列
    getTableColumn: function () {
      this.$getJSON(apis.TableColumnGet, { tableCode: 'usage_month' }).then((res) => {
        const list = res.data;

        // 数组切两段 （平均清洁得分 清洁面积ft² 清洁时长 小时 清洁天数）
        const splitNumber = list.findIndex(i => i.columnCode === 'meetGoalCount');
        this.tableColumn = list.slice(0, splitNumber);
        if (!this.isCoJv) {
          this.tableColumn = this.tableColumn.filter(t => t.columnCode !== 'customerName');
        }
        // 权限
        // 机器 - 列表 usagemonth_machine_list
        // 机器 - 导出 usagemonth_machine_export
        // 机器 - 清洁面积 usagemonth_machine_cleanArea
        // 机器 - 清洁时长 usagemonth_machine_cleanTime
        // 机器 - 清洁天数 usagemonth_machine_cleanDay

        // 表格列
        // +机身号 bodyNum
        //          202401
        //          202312
        //          202311
        //          202310
        // -达标次数 meetGoalCount
        // -平均清洁得分 cleanScoreAvg
        // 清洁面积ft²  cleanArea
        // 清洁时长小时 usageTime
        // 清洁天数 cleanDays
        // i.columnCode !== 'meetGoalCount'
        // i.columnCode !== 'cleanScoreCount'
        // this.funcView.usagemonth_machine_cleanArea&&  i.columnCode !== 'cleanArea'
        // this.funcView.usagemonth_machine_cleanTime&&  i.columnCode !== 'usageTime'
        // this.funcView.usagemonth_machine_cleanDay&&  i.columnCode !== 'cleanDays'
        this.cleanColumn = list
          .slice(splitNumber)
          .filter(
            item => !(
              item.columnCode === 'meetGoalCount'
                || item.columnCode === 'cleanScoreAvg'
                || (item.columnCode === 'cleanArea' && !this.funcView.usagemonth_machine_cleanArea)
                || (item.columnCode === 'usageTime' && !this.funcView.usagemonth_machine_cleanTime)
                || (item.columnCode === 'cleanDays' && !this.funcView.usagemonth_machine_cleanDay)
            )
          );
        // 最近4个月
        this.monthArr = [
          this.$moment().format('YYYYMM'),
          this.$moment().subtract(1, 'months').format('YYYYMM'),
          this.$moment().subtract(2, 'months').format('YYYYMM'),
          this.$moment().subtract(3, 'months').format('YYYYMM'),
        ];
      });
    },
    // 清空标签
    onClear() {
      this.formSearch.customerName = '';
      this.formSearch.search = '';
      this.formSearch.departmentId = '';
      this.formSearch.departmentName = '';
      this.onPageChange({ page: 1 });
    },

    // 导出数据
    exportRecord: function () {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.$exportFlie(apis.portalSiteDeviceMonthExport, {
        ...this.formSearch,
        departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '',
      }).then(() => {});
    },
    refreshPage() {
      this.getReportPage();
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getReportPage();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.usagemonth-machine-list {
  .el-tabs .el-tabs__item {
    font-size: 14px;
  }

  .table-list {
    background: #ffffff;
    border-radius: 16px;
    padding: 24px 24px 0;
    .header {
      // padding: 24px;
      .label {
        color: #1a1a1a;
        line-height: 40px;
        font-weight: bold;
        float: left;
      }

      .search-content {
        float: right;
      }

      .icon-filter {
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        font-size: 16px;
        width: 40px;
        height: 40px;
        color: $--color-text-primary;
        box-shadow: 0 0 0 1.5px #202945 inset;
        border-radius: 50px;
        cursor: pointer;
      }
    }

    .title {
      height: 40px;
      font-size: 18px;
      font-weight: bold;
      color: #1a1a1a;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
    }

    .table-bd {
      background: #ffffff;
      border-radius: 16px;
      padding: 24px 24px 0;
      margin-top: 24px;
      width: 100%;
      height: 600px;
      .el-table--border th,
      .el-table--border td {
        border-right: 1px solid #ebeef5 !important;
      }
    }
  }
}
</style>
